import { AnalyticsEvents, AnalyticsService } from './analytics.service';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class DummyAnalyticsService extends AnalyticsService {

  constructor() {
    super();
  }

  createEvent(key: AnalyticsEvents, params: {}): void {
    console.log('Analytics event triggered !', { key, params })
  }
}

